<div class="ai-thinking-container" [class.variant-simple]="variant === 'simple'">
    <!-- Sparkle Icon -->
    <div class="ai-sparkle">
        <img [src]="sparkleIcon" alt="" class="sparkle-icon">
        <ng-container *ngIf="variant === 'card'">
            <span class="pulse-dot pulse-dot-top"></span>
            <span class="pulse-dot pulse-dot-bottom"></span>
        </ng-container>
    </div>

    <!-- Title (rotating or custom) -->
    <h2 class="ai-thinking-title" [class.fade-out]="messageFadeState === 'fading'">
        {{ currentMessage }}
    </h2>

    <!-- Subtitle -->
    <div class="ai-thinking-subtitle" *ngIf="subtitle">
        {{ subtitle }}
    </div>

    <!-- Simple variant: indeterminate progress bar -->
    <div class="ai-thinking-progress-simple" *ngIf="variant === 'simple'">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <!-- Progress Bar (optional - for card variant) -->
    <div class="ai-thinking-progress" *ngIf="showProgress && variant === 'card'">
        <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
        <span class="progress-percent">{{ progress }}%</span>
    </div>

    <!-- Steps List (optional) -->
    <div class="ai-thinking-steps" *ngIf="showSteps && steps.length">
        <div class="step" *ngFor="let step of steps; trackBy: trackByStep" [class.completed]="step.completed">
            <mat-icon [svgIcon]="step.completed ? 'icon-v2:check-circle' : 'icon-v2:dashed-circle'"></mat-icon>
            <span>{{ step.label }}</span>
        </div>
    </div>
</div>
